import { StyleSheet, Platform } from 'react-native';

export default StyleSheet.create({
  containerCenter: {
    alignItems: 'center',
    width: '100%',
  },
  sourceImage: {
    width: 92,
    height: 92,
  },
  lottieView: {
    width: 120,
    height: 120,
    alignItems: 'center',
    justifyContent: 'center',
  },
  headerContainer: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginTop: Platform.OS === 'ios' ? 17.7 : 16.9,
  },
  responseTitle: theme => ({
    fontSize: Platform.OS === 'ios' ? 25 : 24,
    fontWeight: 'bold',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: theme.colors.textColorThree,
    marginTop: 15,
    marginBottom: 17,
  }),
  subTitle: (theme, isLoadingError) => ({
    fontSize: 17,
    fontWeight: 'normal',
    fontStyle: 'normal',
    lineHeight: 23,
    letterSpacing: 0,
    color: isLoadingError ? theme.colors.subtitle : theme.colors.textColorThree,
    width: '100%',
    paddingHorizontal: 1,
    marginTop: isLoadingError ? 15 : 0,
    marginBottom: isLoadingError ? 15 : 90,
  }),

  alignCenter: {
    textAlign: 'center',
  },
  modalButton: {
    marginTop: 15,
    width: '100%',
  },
  modalButtonText: {
    fontSize: Platform.OS === 'ios' ? 18.6 : 18,
  },
});
